import React, { Component } from 'react';

import { FormEdit } from 'Components/FormEdit';
import TextInput from 'Components/inputs/Text';

// Only the translated label (targetDescription) is editable here. The rule's rank and
// tournament are intentionally not shown: on a rankId-keyed rule they are partial/misleading
// (a rule can span several ranks and is attached to a single, arbitrary tournament).
export default class Form extends Component {
  config = {
    fields: ['id', 'targetDescription'],
    disposition: [
      {
        fields: [{ name: 'targetDescription', component: TextInput, size: 12 }],
      },
    ],
  };

  render() {
    const { data, onSubmit } = this.props;

    return (
      <FormEdit
        key={data.id}
        form={`rankingRuleReferential_${data.id}`}
        onSubmit={onSubmit}
        data={data}
        config={this.config}
        useUserRestriction
      />
    );
  }
}
